export default {
  settingsBlob: (state, getters, rootState, rootGetters) => {
    const blob = rootGetters['blob/get']('concilio--site-settings')

    return (Object.keys(blob).length > 0 && Object.keys(blob).includes('cookiebar')) ? blob.cookiebar : getters.defaultSettings
  },
  currentSettings: (state) => state.settings,
  defaultSettings: (state) => state.defaultSettings
}
